package dk.rheasoft.csaware.api.access

import kotlinx.serialization.Serializable

@Serializable
data class Grant(val feature: MainFeature, val permissions: Set<Permission>)
